module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAYCAYAAAAh8HdUAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAzUlEQVQ4ja3U4Q2CMBAF4GcnYIIL3UA3cBRH0AkME6AbuIlsoBto3gSOYI4ACeWuYLB/INe8fm1p2cBoJEsAL6sPQAxOx9mp30TkPZHmFA1ZkqdcNKAvIymjfDpFn0glT7n2gZG0VEmlRcogkdwCeBgBXfguDfVS7ShVGmglknsAd0sRkWiNFDJrqZz6ZMsXtZAZ0ZsBgog0ABqjryR5yE3v5GkkCzMkIk899pYG4JgW1x2j7thbWpFq66/GjDZ8gv9c94ymrdV+/4UB8Qv6e1R/Cf0fewAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/62.png
// module id = jbKu
// module chunks = 1